const translations = {
  "en": {
    "Annual": "Annual",
    "Complete": "Complete",
    "Ed Complete": "Ed Complete",
    "Free": "Free",
    "Lifetime": "Lifetime",
    "Monthly": "Monthly",
    "Trial": "Trial",
    "Weekly": "Weekly"
  },
  "zh-tw": {
    "Annual": "年度",
    "Complete": "Complete",
    "Ed Complete": "Ed Complete",
    "Free": "免費",
    "Lifetime": "終身",
    "Monthly": "每月",
    "Trial": "試用",
    "Weekly": "每週"
  }
};

export default translations;
